<template>
  <div class="main-bas">
    <div class="title-jibne">DCI作品添加</div>

    <el-steps :active="active" finish-status="success" class="stepscc">
      <el-step title="选择办理身份"></el-step>
      <el-step title="上传作品"></el-step>
      <el-step title="权属"></el-step>
      <el-step title="确认信息"></el-step>
    </el-steps>

    <el-card v-if="form.errorReasonCn" class="stepscc-err">
      失败原因： {{ form.errorReasonCn }}
    </el-card>

    <!-- 审核红线清单（仅展示提示，不影响提交） -->
    <el-card
      v-if="active >= 1 && registrationTips"
      shadow="never"
      class="risk-tip-card"
    >
      <div class="risk-tip-title">{{ registrationTips.riskTitle }}</div>
      <div class="risk-tip-intro">{{ registrationTips.riskIntro }}</div>
      <div class="risk-tip-manual" v-if="registrationTips.manualUrl">
        {{ registrationTips.manualLabel }}：
        <a :href="registrationTips.manualUrl" target="_blank" rel="noopener noreferrer">{{
          registrationTips.manualUrl
        }}</a>
      </div>
      <ul class="risk-tip-list">
        <li v-for="(item, index) in (registrationTips.riskItems || [])" :key="index">
          {{ item }}
        </li>
      </ul>
    </el-card>

    <!-- Unnamed (动态面板) -->
    <div class="unslider" v-if="active == 0">
      <div
        @click="
          () => {
            clickinfo = 1
            active = 1
          }
        "
      >
        <div><i class="el-icon-user"></i></div>
        <div>我是著作权人</div>
      </div>
      <div
        @click="
          () => {
            clickinfo = 2
            active = 1
          }
        "
      >
        <div><i class="el-icon-house"></i></div>
        <div>我是机构代理</div>
      </div>
    </div>
    <div class="asefaeaf" v-if="active == 1">
      <el-table
        :data="sameWorkList"
        border
        class="table-dci"
        v-if="sameWorkList.length > 0 && active == 1"
      >
        <el-table-column width="100" label="作品列表" prop="workName">
          <template slot-scope="scope">
            <div class="showStatus">作品 {{ scope.$index + 1 }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="workName" label="作品名称"> </el-table-column>
        <el-table-column prop="creationCompletionDate" label="创作完成日期">
        </el-table-column>
        <el-table-column prop="publicationStatus" label="创作状态">
          <template slot-scope="scope">
            <div class="showStatus">原创</div>
          </template>
        </el-table-column>
        <el-table-column prop="firstPublicationDate" label="首次发表日期">
          <template slot-scope="scope">
            <div class="showStatus">
              {{
                scope.row.publicationStatus == 'ON_PUBLISHED'
                  ? '未发表'
                  : scope.row.firstPublicationDate
              }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
            <el-button type="primary" @click="copyrigEdit(scope)"
              >编辑</el-button
            >
            <el-button type="danger" @click="copyrightDel(scope)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-card shadow="never" class="card-aut-cc">
        <el-form
          ref="formName"
          :model="form"
          label-width="200px"
          class="form-aut"
          :rules="rules"
          v-if="active == 1"
        >
          <el-form-item label="作品上传：">
            <el-upload
              :disabled="isLook || !!dciWorkId"
              class="avatar-uploader"
              :limit="1"
              action="#"
              drag
              :before-remove="beforeRemove"
              :before-upload="beforeAvatarUpload"
              :auto-upload="false"
              :on-change="handleChange"
              show-file-list
              accept=".jpg, .jpeg, .png, .mp3, .wav, .mp4, .avi, .wmv, .pdf"
              :file-list="fileList"
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                将文件拖到此处，或<em>点击上传</em>
              </div>

              <el-progress
                v-if="percentage != 0"
                :percentage="percentage"
              ></el-progress>
            </el-upload>
            <div class="work-upload-edit-tip" v-if="dciWorkId">
              暂不支持图样修改，请直接点击【上传作品】按钮重新上传图样。
            </div>
            <el-button
              @click="
                downFile(
                  workFileIdLocalUpd ? workFileIdLocalUpd : form.workFileIdLocal
                )
              "
              class="el-button-cfile"
              v-if="
                workFileIdLocalUpd ? workFileIdLocalUpd : form.workFileIdLocal
              "
              type="text"
            >
              当前文件：
              {{
                workFileIdLocalUpd ? workFileIdLocalUpd : form.workFileIdLocal
              }}</el-button
            >
            <!-- <el-button type="text" @click="downloadFile">下载文件</el-button> -->
          </el-form-item>
          <el-form-item label="作品名称:" prop="workName">
            <el-input v-model.trim="form.workName" :disabled="isLook"></el-input>
            <div
              class="work-name-tip"
              v-if="form.fileType === 'TEXT' && registrationTips.textFileNameTip"
            >
              {{ registrationTips.textFileNameTip }}
            </div>
            <div class="work-name-tip" v-if="showAiNameTip && registrationTips.aiNameTip">
              {{ registrationTips.aiNameTip }}
            </div>
          </el-form-item>

          <el-form-item label="作品类型:" prop="workCategory">
            <el-select
              v-model="form.workCategory"
              placeholder="请选择作品类型"
              class="el-select-cc"
              :disabled="isLook"
            >
              <el-option
                :label="item.label"
                :value="item.value"
                v-for="item in WorkCategoryType"
                :key="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="文件类型" prop="fileType">
            <el-select
              :disabled="!!form.errorReasonCn"
              v-model="form.fileType"
              placeholder="请选择作品类型"
              class="el-select-cc"
            >
              <el-option
                :label="item.label"
                :value="item.value"
                v-for="item in fileTypeType"
                :key="item.value"
              ></el-option>
            </el-select>
          </el-form-item>

          <!-- 创作信息 -->
          <div>
            创作信息

            <el-form-item label="作品创作性质:" prop="creationNature">
              <el-select
                :disabled="isLook"
                v-model="form.creationNature"
                placeholder="作品创作性质"
                class="el-select-cc"
              >
                <el-option label="原创" value="ORIGINAL"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="创作完成日期" prop="creationCompletionDate">
              <el-date-picker
                :disabled="isLook"
                placeholder="选择日期"
                v-model="form.creationCompletionDate"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptions"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="地区编码" prop="creationCompletionCode">
              <el-cascader
                :disabled="isLook"
                filterable
                v-model="form.creationCompletionCode"
                :options="creationCompletionCodeOptions"
              ></el-cascader>
            </el-form-item>
          </div>
          <!-- 发表信息---- -->
          <div>
            发表信息
            <el-form-item label="作品发表状态:" prop="publicationStatus">
              <el-select
                :disabled="isLook"
                v-model="form.publicationStatus"
                placeholder="作品发表状态"
                class="el-select-cc"
              >
                <el-option label="作品已发表" value="PUBLISHED"></el-option>
                <el-option
                  disabled
                  label="未发表"
                  value="ON_PUBLISHED"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              v-if="form.publicationStatus == 'PUBLISHED'"
              label="首次发表日期:"
              prop="firstPublicationDate"
            >
              <el-date-picker
                :disabled="isLook"
                placeholder="选择日期"
                v-model="form.firstPublicationDate"
                value-format="yyyy-MM-dd"
                :picker-options="firstPublishPickerOptions"
              ></el-date-picker>
            </el-form-item>
            <el-form-item
              v-if="form.publicationStatus == 'PUBLISHED'"
              label="首次发表地区编码:"
              prop="firstPublicationCode"
            >
              <el-cascader
                :disabled="isLook"
                filterable
                v-model="form.firstPublicationCode"
                :options="creationCompletionCodeOptions"
              ></el-cascader>
            </el-form-item>
          </div>

          <el-form-item>
            <el-button type="primary" @click="nextNewClick" v-if="!dciWorkId">
              同作者再次添加作品
            </el-button>
            <el-button
              type="primary"
              @click="nextNewEDitClick"
              v-if="!dciWorkId && sameWorkListitemID"
            >
              更新当前编辑作品
            </el-button>
            <el-button type="primary" @click="nextClick"> 下一步 </el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </div>
    <el-row class="nave-dd">
      <el-form
        ref="formName2"
        :model="formAousz"
        label-width="255px"
        class="form-aut"
        :rules="rules"
        v-if="active == 2"
      >
        <el-card shadow="never" class="card-aut-cc">
          <el-form-item
            label="权利归属方式:"
            :rules="{
              required: true,
              message: '填写完整内容',
              trigger: 'blur'
            }"
          >
            <el-select
              :disabled="clickinfo == 1"
              v-model="form.ownershipWay"
              placeholder="权利归属方式"
              class="el-select-cc"
              @change="ownershipWayChange"
            >
              <el-option
                :label="item.label"
                :value="item.value"
                v-for="item in ownershipWayType"
                :key="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-card>
        <el-card shadow="never" class="card-aut-cc">
          <div class="span-cc">* 是否多个著作人:</div>
          <div class="seccbtn">
            <div :class="chekbtnClassFo">
              <!--  @click="
                () => {
                  isduogeName = false;
                  chekbtnClassFo = 'chekbtn';
                  chekbtnClassIs = '';
                  formAousz.authorNameList = formAousz.authorNameList.slice(
                    0,
                    1
                  );
                }
              " -->
              否
            </div>
            <div :class="chekbtnClassIs">
              <!--  @click="
                () => {
                  isduogeName = true;
                  chekbtnClassFo = '';
                  chekbtnClassIs = 'chekbtn';
                  formAousz.authorNameList = formAousz.authorNameList.slice(
                    0,
                    1
                  );
                }
              " -->
              是
            </div>
          </div>
        </el-card>
        <el-card shadow="never" class="card-aut-cc">
          <div class="span-cc">* 著作权人:</div>
          <div v-for="(item, index) in formAousz.authorNameList" :key="index">
            <!-- :label="form.ownershipWay == 'PERSON' ? '自然人：' : '机构名称：'" -->
            <el-form-item
              :label="authorNametText"
              :prop="'authorNameList.' + index + '.authorName'"
              :rules="{
                required: true,
                message: '填写完整内容',
                trigger: 'blur'
              }"
            >
              <el-input
                v-model.trim="item.authorName"
                :disabled="isLook || (clickinfo == 1 && index == 0)"
              ></el-input>
            </el-form-item>
            <!-- :label="
                form.ownershipWay == 'PERSON'
                  ? '*身份证号：'
                  : '*统一社会信用代码：'
              " -->
            <el-form-item
              :label="SignatureNameText"
              :prop="'authorNameList.' + index + '.authorSignature'"
              :rules="{
                required: true,
                message: '填写完整内容',
                trigger: 'blur'
              }"
            >
              <el-input
                v-model="item.authorSignature"
                :disabled="isLook || (clickinfo == 1 && index == 0)"
              ></el-input>
            </el-form-item>
            <el-button @click="sreeImg(item)" type="text">保存</el-button>
            <el-button
              v-if="isduogeName"
              type="text"
              @click="
                () => {
                  formAousz.authorNameList.push({
                    authorName: '',
                    authorSignature: ''
                  })
                }
              "
              >+添加著作权人</el-button
            >
            <el-button
              type="danger"
              icon="el-icon-delete"
              circle
              v-if="index > 0"
              @click="
                () => {
                  formAousz.authorNameList.splice(index, 1)
                }
              "
            ></el-button>
            <el-divider v-if="isduogeName"></el-divider>
          </div>
        </el-card>

        <!-- <el-form-item label="原创声明（选填）:" prop="originalStatement">
        <el-input v-model="form.originalStatement"></el-input>
      </el-form-item> -->
        <!-- 权利信息 -->
        <el-card shadow="never" class="card-aut-cc">
          <div class="span-cc">* 作者:</div>
          <div
            v-if="
              form.ownershipWay == 'PERSON' || form.ownershipWay == 'ENTERPRISE'
            "
          >
            <el-form-item
              label="作者姓名:"
              :rules="{
                required: true,
                message: '请保存作者姓名',
                trigger: 'blur'
              }"
            >
              <el-input v-model="form.authorName" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item
              label="作者署名:"
              :rules="{
                required: true,
                message: '请保存作者署名',
                trigger: 'blur'
              }"
            >
              <el-input
                v-model="form.authorSignature"
                :disabled="true"
              ></el-input>
            </el-form-item>
          </div>
          <div
            v-if="
              form.ownershipWay == 'EMPLOYMENT' ||
              form.ownershipWay == 'COMISSION'
            "
          >
            <div
              v-for="(item, index) in authorSignatureList"
              :key="index + 600"
            >
              <el-form-item
                :label="authorSiText"
                :rules="{
                  required: true,
                  message: '请输入作者姓名或名称，与身份证明文件保持一致',
                  trigger: 'blur'
                }"
              >
                <div class="author-input-row">
                  <el-input
                    placeholder="请输入作者姓名或名称，与身份证明文件保持一致"
                    v-model.trim="item.authorName"
                  ></el-input>
                  <el-button
                    v-if="index > 0"
                    type="danger"
                    icon="el-icon-delete"
                    circle
                    class="author-delete-btn"
                    @click="authorSignatureList.splice(index, 1)"
                  ></el-button>
                </div>
                <div v-if="isAuthorConflict(item.authorName)" class="el-form-item__error">
                  著作权人名称不能与作者名称一致
                </div>
              </el-form-item>
            </div>
          </div>
          <el-button
            v-if="
              form.ownershipWay == 'EMPLOYMENT' ||
              form.ownershipWay == 'COMISSION'
            "
            type="text"
            @click="
              () => {
                authorSignatureList.push({
                  authorName: '',
                  authorSignature: ''
                })
              }
            "
            >+添加作者</el-button
          >
        </el-card>
        <el-card shadow="never" class="card-aut-cc">
          <div class="span-cc">* 权利信息:</div>
          <el-form-item
            label="作品权利范围:"
            :rules="{
              required: true,
              message: '填写完整内容',
              trigger: 'blur'
            }"
          >
            <el-select
              :disabled="
                form.ownershipWay == 'PERSON' ||
                form.ownershipWay == 'ENTERPRISE'
              "
              clearable
              multiple
              v-model="rightScope"
              placeholder="请选择作品类型"
              class="el-select-cc"
            >
              <el-option
                :label="item.label"
                :value="item.value"
                :disabled="item.disabled"
                v-for="item in rightScopeType"
                :key="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="权利取得方式:"
            :rules="{
              required: true,
              message: '填写完整内容',
              trigger: 'blur'
            }"
          >
            <el-select
              :disabled="isLook"
              v-model="form.rightObtainWay"
              placeholder="权利取得方式"
              class="el-select-cc"
            >
              <el-option label="原创" value="ORIGINAL"></el-option>
            </el-select>
          </el-form-item>
        </el-card>
        <!-- <el-form-item label="真实意愿表达信息:" prop="preRegistrationTrueWill">
        <el-select
          v-model="form.preRegistrationTrueWill"
          placeholder="请选择真实意愿表达信息"
          class="el-select-cc"
        >
          <el-option
            :label="item.label"
            :value="item.value"
            v-for="item in preRegistrationTrueWillType"
            :key="item.value"
          ></el-option>
        </el-select>
      </el-form-item> -->

        <!-- <el-form-item label="著作权人用户id列表:" prop="copyrightOwnerIds">
          <el-select
            :disabled="isLook"
            v-model="form.copyrightOwnerIds"
            placeholder="请选择真实意愿表达信息"
            class="el-select-cc"
            multiple
            @change="handleChange"
          >
            <el-option
              :label="item.label"
              :value="item.value"
              v-for="item in copyrightOwnerIdsType"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item> -->

        <el-form-item class="btn-cc-disc">
          <el-button @click="active = 1"> 上一步 </el-button>
          <el-button @click="onSubmitUpdate" type="primary"> 下一步 </el-button>
          <!-- <el-button @click="onSubmitisLook"> 返回 </el-button> -->
        </el-form-item>
      </el-form>
    </el-row>

    <el-row class="nave-dd" v-if="active == 3">
      <el-card
        shadow="never"
        class="card-aut-cc"
        v-if="sameWorkList.length > 1"
      >
        <div class="span-cc">作品列表</div>
        <div class="seccbtn-sfda">
          <div
            :class="chekbtnClassFoList[index]"
            v-for="(item, index) in sameWorkList"
            :key="index + 100"
            @click="chekbtn(index)"
          >
            {{ item.workName }}
          </div>
        </div>
      </el-card>
      <el-card shadow="never" class="card-aut-cc">
        <div class="never-span-cc">
          <div>
            <div class="nawe-sadg">
              <div>作品</div>
              <div>
                <el-button type="text" @click="editInfo()" v-if="!isLook"
                  >修改</el-button
                >
              </div>
            </div>
            <div class="nawe-sadg">
              <div>作品名称：</div>
              <div>{{ infoForm.workName }}</div>
            </div>
            <div class="nawe-sadg">
              <div>文件类型:</div>
              <div>{{ infoForm.fileType }}</div>
            </div>
            <div class="nawe-sadg">
              <div>文件名称:</div>
              <div>{{ this.infoForm.workFileIdLocal }}</div>
            </div>
          </div>
          <div>
            <div>作品样本：</div>
            <div v-loading="isShow">
              <file-preview
                :file-data="selectedFile"
                :file-type="fileType"
                style="width: 300px; height: 200px"
              ></file-preview>
            </div>
          </div>
        </div>
      </el-card>

      <el-card shadow="never" class="card-aut-cc">
        <div class="never-span-cc">
          <div>
            <div class="nawe-sadg">
              <div>办理身份:</div>
              <div>{{ clickinfo == 1 ? '著作权人' : '机构代理' }}</div>
            </div>
          </div>
        </div>
      </el-card>

      <el-card shadow="never" class="card-aut-cc">
        <div class="never-span-cc">
          <div>
            <div class="nawe-sadg">
              <div>作品类型:</div>
              <div>
                {{ getLabelByValue(infoForm.workCategory, WorkCategoryType) }}
              </div>
            </div>
          </div>
        </div>
      </el-card>

      <el-card shadow="never" class="card-aut-cc">
        <div class="never-span-cc">
          <div>
            <div class="nawe-sadg">
              <div>创作类型:</div>
              <div>原创</div>
            </div>
            <div class="nawe-sadg">
              <div>创作完成日期:</div>
              <div>{{ infoForm.creationCompletionDate }}</div>
            </div>
          </div>
          <div>
            <div class="nawe-sadg"></div>
            <div class="nawe-sadg">
              <div>创作完成地点:</div>
              <div>{{ getAreaNameByCode(infoForm.creationCompletionCode) }}</div>
            </div>
          </div>
        </div>
      </el-card>

      <el-card shadow="never" class="card-aut-cc">
        <div class="never-span-cc">
          <div>
            <div class="nawe-sadg">
              <div>发表状态:</div>
              <div>已发表</div>
            </div>
            <div class="nawe-sadg">
              <div>首次发表日期:</div>
              <div>{{ infoForm.firstPublicationDate }}</div>
            </div>
          </div>
          <div>
            <div class="nawe-sadg"></div>
            <div class="nawe-sadg">
              <div>首次发表地点:</div>
              <div>{{ getAreaNameByCode(infoForm.firstPublicationCode) }}</div>
            </div>
          </div>
        </div>
      </el-card>

      <el-card shadow="never" class="card-aut-cc">
        <div class="never-span-cc">
          <div>
            <div class="nawe-sadg">
              <div>权利取得方式:</div>
              <div>原创</div>
            </div>
            <div class="nawe-sadg">
              <div>权利归属方式:</div>
              <div>
                {{ getLabelByValue(form.ownershipWay, ownershipWayType) }}
              </div>
            </div>
            <div
              class="nawe-sadg"
              v-for="(item, index) in formAousz.authorNameList"
              :key="index + 300"
            >
              <div>{{ index == 0 ? '著作权人:' : '' }}</div>

              <div>
                {{ form.ownershipWay == 'PERSON' ? '自然人： ' : '机构名称：' }}
                {{ item.authorName }}
              </div>
              <div class="nawe-sadg-sdfa">
                {{
                  form.ownershipWay == 'PERSON'
                    ? '身份证号： '
                    : '统一社会信用代码： '
                }}
                {{ item.authorSignature }}
              </div>
            </div>
          </div>
        </div>
      </el-card>

      <el-card shadow="never" class="card-aut-cc">
        <div class="never-span-cc">
          <div>
            <div class="nawe-sadg">
              <div>作者:</div>
              <div>{{ form.authorName }}</div>
            </div>
          </div>
          <div>
            <div class="nawe-sadg">
              <div>署名:</div>
              <div>{{ form.authorSignature }}</div>
            </div>
          </div>
        </div>
      </el-card>
      <el-card shadow="never" class="card-aut-cc">
        <div class="never-span-cc">
          <div>
            <div class="nawe-sadg">
              <div>权利拥有情况:</div>

              <div>{{ getRightScopeLeabe() }}</div>
            </div>
          </div>
        </div>
      </el-card>

      <el-card shadow="never" class="card-aut-cc">
        <el-button @click="active = 2" v-if="!isLook"> 上一步 </el-button>
        <el-button @click="onSubmitisLook" v-if="isLook"> 返回 </el-button>
        <el-button type="primary" @click="onSubmitisLook3" v-if="!isLook">
          提交
        </el-button>
      </el-card>
    </el-row>

    <el-dialog title="预览" :visible.sync="dialogVisilock" width="80%">
      <file-preview
        class="btn-isooreview"
        :file-data="selectedFile"
        :file-type="fileType"
        style="width: 100%; height: 68vh"
      ></file-preview>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="downCheck(dialogVisilockpath)"
          >下载</el-button
        >
        <el-button @click="dialogVisilock = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  upload,
  workSave,
  userList,
  workInfo,
  workUpdate,
  getByCertNo
} from '@/api/user.js'
import {
  DEFAULT_REGISTRATION_TIPS,
  loadRegistrationTips,
  matchAiNameKeyword
} from '@/utils/registrationTipsLoader.js'
// cardOptions 从 window.CARD_OPTIONS 获取（在 index.html 中预加载）
export default {
  name: '',
  components: {},
  mixins: [],
  props: {},
  data () {
    return {
      registrationTips: { ...DEFAULT_REGISTRATION_TIPS },
      workFileIdUpd: '',
      workFileIdLocalUpd: '',
      fileSizeUpd: '',
      fileDurationMinutesUpd: '',
      active: 0,
      // 1我是著作权人 2我是机构代理
      clickinfo: 1,
      form: {
        // 作品名称，最长50个字符
        workName: '',

        // DCI用户ID，通过DCI用户注册获取
        dciUserId: '',

        // 作品类型，详见 WorkCategory 文档
        workCategory: '',

        // 作品文件路径，通过 getUploadUrl 接口上传文件获取
        workFileId: '',

        // 文件类型，详见 FileType 文档
        fileType: '',

        // 创作信息，详见 DciCreationInfo 文档
        creationNature: 'ORIGINAL', // 作品创作性质
        creationCompletionDate: '', // 创作完成日期
        creationCompletionCode: '', // 地区编码

        // 发表信息，详见 DciPublicationInfo 文档
        publicationStatus: 'PUBLISHED', // 作品发表状态
        firstPublicationDate: '', // 首次发表日期
        firstPublicationCode: '', // 首次发表地区编码

        // 作者姓名，需与著作权人姓名保持一致
        authorName: '',

        // 作者署名，需与 authorName 保持一致
        authorSignature: '',

        // 原创声明（选填）
        originalStatement: '',

        // 权利信息，详见 DciRightInfo 文档
        rightScope: 'ALL', // 作品权利范围
        rightObtainWay: 'ORIGINAL', // 权利取得方式
        ownershipWay: 'PERSON', // 权利归属方式

        // 真实意愿表达信息，详见 PreRegistrationTrueWill 文档
        preRegistrationTrueWill: 'PASSWORD',

        // 暂时不传
        // 著作权人用户id列表，长度为1且著作权人需与申请人一致
        copyrightOwnerIds: [],

        // A音视频文件播放分钟时长，向上取整
        fileDurationMinutes: 0,
        // A文件大小，向上取整 MB
        fileSize: 0,
        // A代理人id sys_user表id
        proxy: '',
        // A作品文件路径 202211251400chushibiao.pdf 文件OSS Id,通过getUploadUrl接口上传文件获取
        workFileId: '',
        // A作品文件路径 本系统OSS
        workFileIdLocal: ''
      },
      // 储存多个著作人信息
      copyrightOwnerIdsList: [],

      // 文件保存file
      file: '',
      fileTypeType: [
        { value: 'TEXT', label: '文本（限制pdf类型）（限制文件大小10M）' },
        {
          value: 'IMAGE',
          label:
            '图片（限制jpg、jpeg、png类型）（限制文件大小5M）（图片像素不低于400x400，不高于5000x5000）'
        },
        {
          value: 'AUDIO',
          label: '音频（限制mp3、wav类型）（限制文件大小50M）'
        },
        {
          value: 'VIDEO',
          label: '视频（限制mp4、avi、wmv类型）（限制文件大小200M）'
        },
        {
          value: 'PDF_IMAGE',
          label: '系列图（限制pdf类型）（限制文件大小10M）(限制子图数量2-30)'
        }
      ],
      fileTypeTypeinit: [
        { value: 'TEXT', label: '文本（限制pdf类型）（限制文件大小10M）' },
        {
          value: 'IMAGE',
          label:
            '图片（限制jpg、jpeg、png类型）（限制文件大小5M）（图片像素不低于400x400，不高于5000x5000）'
        },
        {
          value: 'AUDIO',
          label: '音频（限制mp3、wav类型）（限制文件大小50M）'
        },
        {
          value: 'VIDEO',
          label: '视频（限制mp4、avi、wmv类型）（限制文件大小200M）'
        },
        {
          value: 'PDF_IMAGE',
          label: '系列图（限制pdf类型）（限制文件大小10M）(限制子图数量2-30)'
        }
      ],
      WorkCategoryType: [
        {
          value: 'WORD',
          label: '文字作品，支持文件类型 .pdf'
        },
        {
          value: 'ORAL',
          label: '口述作品，支持文件类型 .mp3;.wav'
        },
        {
          value: 'MUSIC',
          label: '音乐作品，支持文件类型 .mp3;.wav'
        },
        {
          value: 'DRAMA',
          label: '戏剧作品，支持文件类型 .pdf'
        },
        {
          value: 'QUYI',
          label: '曲艺作品，支持文件类型 .pdf'
        },
        {
          value: 'DANCE',
          label: '舞蹈作品，支持文件类型 .mp4;.wmv;.avi'
        },
        {
          value: 'ACROBATICS',
          label: '杂技作品，支持文件类型 .mp4;.wmv;.avi'
        },
        {
          value: 'ART',
          label: '美术作品，支持文件类型 jpg;.jpeg;.png;.pdf'
        },
        {
          value: 'ARCHITECTURE',
          label: '建筑作品，支持文件类型 jpg;.jpeg;.png;.pdf'
        },
        {
          value: 'PHOTOGRAPHY',
          label: '摄影作品，支持文件类型 jpg;.jpeg;.png;.pdf'
        },
        {
          value: 'MOVIE',
          label: '电影作品，支持文件类型 .mp4;.wmv;.avi'
        },
        {
          value: 'AUDIOVISUAL',
          label: '类似摄制电影方法创作的作品，支持文件类型 .mp4;.wmv;.avi'
        },
        {
          value: 'DESIGN',
          label: '工程设计图、产品设计图，支持文件类型 jpg;.jpeg;.png;.pdf'
        },
        {
          value: 'DIAGRAM',
          label: '示意图，支持文件类型 jpg;.jpeg;.png;.pdf'
        },
        {
          value: 'MODEL',
          label: '模型，支持文件类型 jpg;.jpeg;.png;.pdf'
        }
      ],
      WorkCategoryTypeinit: [
        {
          value: 'WORD',
          label: '文字作品，支持文件类型 .pdf'
        },
        {
          value: 'ORAL',
          label: '口述作品，支持文件类型 .mp3;.wav'
        },
        {
          value: 'MUSIC',
          label: '音乐作品，支持文件类型 .mp3;.wav'
        },
        {
          value: 'DRAMA',
          label: '戏剧作品，支持文件类型 .pdf'
        },
        {
          value: 'QUYI',
          label: '曲艺作品，支持文件类型 .pdf'
        },
        {
          value: 'DANCE',
          label: '舞蹈作品，支持文件类型 .mp4;.wmv;.avi'
        },
        {
          value: 'ACROBATICS',
          label: '杂技作品，支持文件类型 .mp4;.wmv;.avi'
        },
        {
          value: 'ART',
          label: '美术作品，支持文件类型 jpg;.jpeg;.png;.pdf'
        },
        {
          value: 'ARCHITECTURE',
          label: '建筑作品，支持文件类型 jpg;.jpeg;.png;.pdf'
        },
        {
          value: 'PHOTOGRAPHY',
          label: '摄影作品，支持文件类型 jpg;.jpeg;.png;.pdf'
        },
        {
          value: 'MOVIE',
          label: '电影作品，支持文件类型 .mp4;.wmv;.avi'
        },
        {
          value: 'AUDIOVISUAL',
          label: '类似摄制电影方法创作的作品，支持文件类型 .mp4;.wmv;.avi'
        },
        {
          value: 'DESIGN',
          label: '工程设计图、产品设计图，支持文件类型 jpg;.jpeg;.png;.pdf'
        },
        {
          value: 'DIAGRAM',
          label: '示意图，支持文件类型 jpg;.jpeg;.png;.pdf'
        },
        {
          value: 'MODEL',
          label: '模型，支持文件类型 jpg;.jpeg;.png;.pdf'
        }
      ],
      creationCompletionCodeOptions: window.CARD_OPTIONS || [],
      rightScopeType: [
        { value: 'ALL', label: '全选', disabled: false },
        { value: 'PUBLISH', label: '发表权' },
        { value: 'AUTHORSHIP', label: '署名权', disabled: false },
        { value: 'MODIFY', label: '修改权' },
        { value: 'PROTECT_INTEGRITY', label: '保护作品完整权' },
        { value: 'COPY', label: '复制' },
        { value: 'ISSUE', label: '发行权' },
        { value: 'RENTAL', label: '出租' },
        { value: 'EXHIBIT', label: '展览权' },
        { value: 'PERFORM', label: '表演权' },
        { value: 'SHOW', label: '放映权' },
        { value: 'BROADCAST_TRADITIONAL', label: '广播权' },
        { value: 'INFO_NET_SPREAD', label: '信息网络传播权' },
        { value: 'CAMERA', label: '摄制权' },
        { value: 'REVISE', label: '改编权' },
        { value: 'TRANSLATE', label: '翻译权' },
        { value: 'COMPILE', label: '汇编权' },
        { value: 'OTHERS', label: '其他' }
      ],
      ownershipWayType: [
        { value: 'PERSON', label: '个人作品' },
        { value: 'ENTERPRISE', label: '法人作品' },
        { value: 'EMPLOYMENT', label: '职务作品' },
        { value: 'COMISSION', label: '委托作品' }
      ],
      preRegistrationTrueWillType: [
        { value: 'PASSWORD', label: '密码验证' },
        { value: 'CONFIRM_SMS', label: '用户短信验证' },
        { value: 'LIVE_SMS', label: '指纹或视频人脸验证' },
        { value: 'CERTIFICATE', label: '电子签名验证' }
      ],
      rules: {
        workName: [
          { required: true, message: '请输入作品名称', trigger: 'blur' }
        ],
        workCategory: [
          { required: true, message: '请选择作品类型', trigger: 'blur' }
        ],
        fileType: [
          { required: true, message: '请择作文件类型', trigger: 'blur' }
        ],
        creationNature: [
          { required: true, message: '请输入选择', trigger: 'blur' }
        ],
        creationCompletionDate: [
          { required: true, message: '请输入创作完成日期', trigger: 'blur' }
        ],
        creationCompletionCode: [
          { required: true, message: '请输入地区编码', trigger: 'blur' }
        ],
        publicationStatus: [
          { required: true, message: '请输入作品发表状态', trigger: 'blur' }
        ],
        firstPublicationDate: [
          { required: true, message: '请输入首次发表日期', trigger: 'blur' }
        ],
        firstPublicationCode: [
          {
            required: true,
            message: '请输入首次发表地区编码',
            trigger: 'blur'
          }
        ],
        authorName: [
          { required: true, message: '请输入作者姓名', trigger: 'blur' }
        ],
        authorSignature: [
          { required: true, message: '请输入作者署名', trigger: 'blur' }
        ],

        rightScope: [
          { required: true, message: '请输入作品权利范围', trigger: 'blur' }
        ],
        rightObtainWay: [
          { required: true, message: '请输入权利取得方式', trigger: 'blur' }
        ],
        ownershipWay: [
          { required: true, message: '请输入权利归属方式', trigger: 'blur' }
        ],
        preRegistrationTrueWill: [
          {
            required: true,
            message: '请输入真实意愿表达信息',
            trigger: 'blur'
          }
        ],
        copyrightOwnerIds: [
          {
            required: true,
            message: '请输入著作权人用户id列表',
            trigger: 'blur'
          }
        ],
        authorName99: [
          {
            required: true,
            message: '请输入内容',
            trigger: 'blur'
          }
        ]
      },
      // 文件类型与限制配置
      fileConfig: {
        pdf: { maxSize: 10, error: 'PDF文件最大支持10M' },
        audio: {
          extensions: ['mp3', 'wav'],
          maxSize: 50,
          error: '音频文件最大支持50M'
        },
        video: {
          extensions: ['mp4', 'avi', 'wmv'],
          maxSize: 200,
          error: '视频文件最大支持200M'
        },
        image: {
          extensions: ['jpg', 'jpeg', 'png'],
          maxSize: 5,
          minPixels: 400,
          maxPixels: 5000,
          error: '图片文件最大支持5M，且尺寸需在400x400-5000x5000之间'
        }
      },
      // 著作权人用户id列表 后台获取
      copyrightOwnerIdsType: [
        {
          value: '', //id
          label: '', //名字
          authorSignature: '' //证件号
        }
      ],

      dciWorkId: '', // 作品id
      isLook: false, // 是否查看
      isduogeName: false, // 是否多个人
      chekbtnClassFo: 'chekbtn',
      chekbtnClassIs: '',

      formAousz: {
        authorNameList: [
          {
            // 证件名字
            authorName: '',
            // 证件号码
            authorSignature: '',
            identityStartTime: '' // 证件有效期开始时间
          }
        ] // 人员列表
      },
      // 同作品列表
      sameWorkList: [
        // {
        //   workFileId: "", // 作品文件id
        //   workFileIdLocal: "", // 作品文件id本系统OSS
        //   workName: "132", // 作品名称
        //   workCategory: "", // 作品类型
        //   fileType: "IMAGE", // 文件类型
        //   creationNature: "", // 作品创作性质
        //   creationCompletionDate: "", // 创作完成日期
        //   creationCompletionCode: "sss", // 地区编码
        //   publicationStatus: "", // 作品发表状态
        //   firstPublicationDate: "", // 首次发表日期
        //   firstPublicationCode: "", // 首次发表地区编码
        // },
      ],
      sameWorkListitemID: '', // 同作品列表id
      chekbtnClassFoList: [
        'chekbtn',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        ''
      ],
      infoForm: {},
      fileList: [],
      selectedFile: [],
      fileType: '',
      percentage: 0,
      isShow: true,
      dialogVisilock: false,
      dialogVisilockpath: '',
      authorSignatureList: [
        {
          authorName: '',
          authorSignature: ''
        }
      ],
      rightScope: ['ALL'],
      authorNametText: '自然人:',
      SignatureNameText: '身份证号:',
      authorSiText: '作者姓名:'
    }
  },
  computed: {
    pickerOptions() {
      return {
        disabledDate (time) {
          return time.getTime() > Date.now()
        }
      }
    },
    firstPublishPickerOptions() {
      return {
        disabledDate: (time) => {
          if(time.getTime() > Date.now()){
            return true
          }
          if (!this.form.creationCompletionDate) return false

          const creationDate = new Date(this.form.creationCompletionDate)
          creationDate.setHours(0, 0, 0, 0)
          return time.getTime() < creationDate.getTime()
        }
      }
    },
    // 计算属性绑定到Vuex store中的userInfo
    userInfo () {
      return this.$store.state.userInfo.user
    },
    // 计算属性绑定到Vuex store中的userInfo
    realInformation () {
      return this.$store.state.realInformation
    },
    isPersonal () {
      return this.realInformation.legalPersonCertName ? false : true
    },
    // 检测职务作品或委托作品时，著作权人是否与作者名称冲突
    hasCopyrightAuthorConflict () {
      if (
        this.form.ownershipWay !== 'EMPLOYMENT' &&
        this.form.ownershipWay !== 'COMISSION'
      ) {
        return false
      }
      const copyrightOwnerNames = this.formAousz.authorNameList
        .map(item => item.authorName.trim())
        .filter(name => name !== '')
      const authorNames = this.authorSignatureList
        .map(item => item.authorName.trim())
        .filter(name => name !== '')
      return copyrightOwnerNames.some(name => authorNames.includes(name))
    },
    // 仅展示提示，不拦截提交
    showAiNameTip () {
      return matchAiNameKeyword(
        this.form.workName,
        this.registrationTips && this.registrationTips.aiKeywords
      )
    }
  },
  watch: {
    infoForm (newVal) {
      this.isShow = true
      if (newVal.workFileIdLocal) {
        this.dialogVisilockClick(newVal.workFileIdLocal)
      }
    }
  },
  async created () {
    // 提示配置异步加载，不阻塞原有业务初始化
    loadRegistrationTips()
      .then(tips => {
        this.registrationTips = tips
      })
      .catch(() => {
        this.registrationTips = { ...DEFAULT_REGISTRATION_TIPS }
      })
    // const res = await userList()
    // if (res && res.code == 200) {
    //   this.copyrightOwnerIdsType = []
    //   res.rows.map(e => {
    //     this.copyrightOwnerIdsType.push({
    //       value: e.dciUserId,
    //       label: e.certName,
    //       authorSignature: e.certificateNumber,
    //       identityStartTime: e.identityStartTime // 证件有效期开始时间
    //     })
    //   })
    // }
    if (this.$route.query.dciWorkId) {
      this.dciWorkId = this.$route.query.dciWorkId
      if (this.$route.query.isLook == 1) {
        this.isLook = true
        this.active = 3
      } else {
        this.active = 1
      }
      const res = await workInfo({
        dciWorkId: this.$route.query.dciWorkId
      })
      if (res && res.code == 200) {
        if (this.isLook) {
          this.infoForm = { ...res.data }
          this.sameWorkList = { ...res.data }
        }
        this.form = res.data

        // 处理2个格式字段
        if (
          this.form.ownershipWay == 'EMPLOYMENT' ||
          this.form.ownershipWay == 'COMISSION'
        ) {
          const authorName = this.form.authorName
          const authorSignature = this.form.authorSignature

          // 1. 将字符串分割成数组
          const names = authorName.split('、')
          const signatures = authorSignature.split('、')

          // 2. 检查长度是否一致
          if (names.length !== signatures.length) {
            // throw new Error('两个字符串的分割结果长度不一致')
          }

          // 3. 构建结果数组
          const result = names.map((name, index) => ({
            authorName: name,
            authorSignature: signatures[index]
          }))

          this.authorSignatureList = result

          this.rightScope = this.form.rightScope.split(',')
        }

        // 是否代理
        if (res.data.proxy) {
          this.clickinfo = 2
        }

        // 反显著作人信息
        if (
          !this.isArrayEmptyOrContainsOnlyEmptyString(
            res.data.copyrightOwnerIds
          )
        ) {
          this.formAousz.authorNameList = []
        }

        this.copyrightOwnerIdsType = []
        const resUser = await userList(res.data.copyrightOwnerIds || [])
        if (resUser && resUser.code == 200) {
          resUser.rows.map(e => {
            this.copyrightOwnerIdsType.push({
              value: e.dciUserId,
              label: e.certName,
              authorSignature: e.certificateNumber,
              identityStartTime: e.identityStartTime // 证件有效期开始时间
            })
            this.formAousz.authorNameList.push({
                authorName: e.certName, //名字
                authorSignature: e.certificateNumber, //证件号
                identityStartTime: e.identityStartTime // 证件有效期开始时间
            })
          })
        }

        // res.data.copyrightOwnerIds.map(e => {
        //   this.copyrightOwnerIdsType.map(i => {
        //     if (i.value == e) {
        //       this.formAousz.authorNameList.push({
        //         authorName: i.label, //名字
        //         authorSignature: i.authorSignature, //证件号
        //         identityStartTime: i.identityStartTime // 证件有效期开始时间
        //       })
        //     }
        //   })
        // })
      }
    } else {
      // 初始化日期
      this.form.creationCompletionDate = this.getNewData()
      this.form.firstPublicationDate = this.getNewData()
    }
  },
  async mounted () {},
  methods: {
    // 检查单个作者名称是否与著作权人名称冲突
    isAuthorConflict (authorName) {
      if (
        this.form.ownershipWay !== 'EMPLOYMENT' &&
        this.form.ownershipWay !== 'COMISSION'
      ) {
        return false
      }
      if (!authorName || authorName.trim() === '') {
        return false
      }
      const copyrightOwnerNames = this.formAousz.authorNameList
        .map(item => item.authorName.trim())
        .filter(name => name !== '')
      return copyrightOwnerNames.includes(authorName.trim())
    },
    getRightScopeLeabe () {
      const result = this.rightScopeType
        .filter(option => this.rightScope.includes(option.value))
        .map(option => option.label)
        .join('、')
      console.log(result, 'zzzzzzzzzzzz')

      return result
    },
    ownershipWayChange (val) {
      if (val == 'EMPLOYMENT' || val == 'COMISSION') {
        this.rightScope = [
          'PUBLISH',
          'MODIFY',
          'PROTECT_INTEGRITY',
          'COPY',
          'ISSUE',
          'RENTAL',
          'EXHIBIT',
          'PERFORM',
          'SHOW',
          'BROADCAST_TRADITIONAL',
          'INFO_NET_SPREAD',
          'CAMERA',
          'REVISE',
          'TRANSLATE',
          'COMPILE',
          'OTHERS'
        ]
        this.rightScopeType[0].disabled = true
        this.rightScopeType[2].disabled = true
      } else {
        this.rightScopeType[0].disabled = false
        this.rightScopeType[2].disabled = false
        this.rightScope = ['ALL']
      }

      if (val == 'PERSON') {
        this.authorNametText = '自然人姓名：'
        this.SignatureNameText = '身份证号：'
        this.authorSiText = '自然人姓名:'
      }

      if (val == 'ENTERPRISE') {
        this.authorNametText = '机构名称（公司名称）：'
        this.SignatureNameText = '统一社会信用代码：'
        this.authorSiText = '自然人姓名:'
      }

      if (val == 'EMPLOYMENT') {
        this.authorNametText = '机构名称（公司名称）：'
        this.SignatureNameText = '统一社会信用代码：'
        this.authorSiText = '自然人姓名:'
      }

       if (val == 'COMISSION') {
        this.authorNametText = '机构名称（公司名称）/自然人姓名：'
        this.SignatureNameText = '统一社会信用代码/身份证号：'
        this.authorSiText = '机构名称（公司名称）/自然人姓名:'
      }
    },
    async dialogVisilockClick (path) {
      const resUrl = await this.$download.file(path)
      this.selectedFile = resUrl
      this.fileType = path.split('/')[0]
      this.isShow = false
    },
    isArrayEmptyOrContainsOnlyEmptyString (arr) {
      // 检查数组是否为空
      if (arr.length === 0) {
        return true // 数组为空
      }

      // 检查数组是否只包含一个空字符串
      if (arr.length === 1 && arr[0] === '') {
        return true // 数组只包含一个空字符串
      }

      return false // 数组不为空且不只包含一个空字符串
    },
    async sreeImg (item) {
      let isMubl = true
      this.form.copyrightOwnerIds = []
      this.copyrightOwnerIdsList = []

      for (
        let index = 0;
        index < this.formAousz.authorNameList.length;
        index++
      ) {
        const e = this.formAousz.authorNameList[index]
        const res = await getByCertNo({
          certNo: e.authorSignature,
          certName: e.authorName
        })
        if (res.code == 200) {
          this.form.copyrightOwnerIds.push(res.data.dciUserId)
          this.copyrightOwnerIdsList.push(res.data) // 储存多个著作人信息
        } else {
          isMubl = false
          this.$message.error('证件号有误：' + res.msg)
          this.form.dciUserId = ''
          this.form.authorName = ''
          this.form.authorSignature = ''
          return false
        }
      }
      console.log(this.copyrightOwnerIdsList, 'this.copyrightOwnerIdsList')
      if (!isMubl) return // 证件号有误阻止流程
      this.form.dciUserId = this.copyrightOwnerIdsList[0].dciUserId
      if (
        this.form.ownershipWay == 'EMPLOYMENT' ||
        this.form.ownershipWay == 'COMISSION'
      ) {
      } else {
        this.form.authorName = this.copyrightOwnerIdsList[0].certName
        this.form.authorSignature = this.copyrightOwnerIdsList[0].certName
      }
    },
    getLabelByValue (value, works) {
      const found = works.find(work => work.value === value)
      return found ? found.label : value
    },
    // 根据地区代码获取地区名称（支持嵌套的cardOptions）
    getAreaNameByCode (code) {
      if (!code) return ''
      for (const province of this.creationCompletionCodeOptions) {
        if (province.children) {
          const found = province.children.find(city => city.value === code)
          if (found) {
            return `${province.label}/${found.label}`
          }
        }
      }
      return code
    },
    chekbtn (i) {
      this.infoForm = this.sameWorkList[i]
      for (let index = 0; index < this.sameWorkList.length; index++) {
        if (i == index) {
          this.$set(this.chekbtnClassFoList, index, 'chekbtn')
        } else {
          this.$set(this.chekbtnClassFoList, index, '')
        }
      }
    },
    onSubmitUpdate () {
      this.$refs.formName2.validate(async valid => {
         // 职务作品或委托作品时，著作权人不能是作者之一
         if (this.hasCopyrightAuthorConflict) {
          this.$message.error('职务作品或委托作品的著作权人不能是作者之一')
          return false
        }
        if (valid) {
          await this.sreeImg()
          console.log(this.form.rightScope, 'form.rightScope')

          if (
            this.form.ownershipWay == 'EMPLOYMENT' ||
            this.form.ownershipWay == 'COMISSION'
          ) {
            if (this.authorSignatureList[0].authorName == '') {
              this.$message.error('请填填写作者信息！')
              return false
            } else {
              this.form.authorName = this.authorSignatureList
                .map(item => item.authorName)
                .join('、')
              this.form.authorSignature = this.authorSignatureList
                .map(item => item.authorName)
                .join('、')
            }
            this.form.rightScope = this.rightScope.join(',')
          } else {
            if (this.form.authorName == '' || this.form.authorSignature == '') {
              this.$message.error('请填保存用户信息')
              return false
            }
          }

          let isFound = false
          this.sameWorkList.map(e => {
            const date1 = new Date(e.creationCompletionDate)
            const date2 = new Date(e.firstPublicationDate)
            const identityStartTime = new Date(
              this.copyrightOwnerIdsList[0].identityStartTime
            )
            if (date1 < identityStartTime || date2 < identityStartTime) {
              this.$message.error(
                '首次发表日期&创作完成日期,不能早于著作权人出生或设立日期'
              )
              isFound = true
            }
          })
          if (isFound) return

          this.infoForm = this.sameWorkList[0]
          this.active = 3
        } else {
          this.$message.error('请填写完整信息')
          return false
        }
      })
    },
    async onSubmitisLook3 () {
      for (let index = 0; index < this.sameWorkList.length; index++) {
        const element = this.sameWorkList[index]

        const res = await workUpdate({
          ...this.form,
          ...element,
          dciUserId: this.form.dciUserId,
          authorName: this.form.authorName,
          authorSignature: this.form.authorSignature,
          errorReasonCn: ''
        })
        console.log(res, 'res')
        if (res.code == 200) {
          this.$message.success('更新作品信息成功')
        } else {
          this.$message.error('更新作品信息失败' + res.msg)
          return false
        }
      }
      this.$router.push('/DCIRegistration')
    },

    onSubmitisLook () {
      this.$router.push({
        path: '/DCIRegistration'
      })
    },
    beforeAvatarUpload (file) {
      const isLt2M = file.size / 1024 / 1024
      const isJPG = file.type === 'image/jpeg'
      console.log(file)
    },
    async handleChange (file) {
      // console.log(isLt2M);
      // 获取文件后缀和类型
      const ext = file.name.split('.').pop().toLowerCase()
      let fileType = 'other'

      // 判断文件类型
      if (ext === 'pdf') {
        fileType = 'pdf'
      } else if (this.fileConfig.audio.extensions.includes(ext)) {
        fileType = 'audio'
      } else if (this.fileConfig.video.extensions.includes(ext)) {
        fileType = 'video'
      } else if (this.fileConfig.image.extensions.includes(ext)) {
        fileType = 'image'
      }
      console.log(fileType, 'fileType')
      // 验证文件大小
      const config = this.fileConfig[fileType]
      if (!config || file.size > config.maxSize * 1024 * 1024) {
        const error = config ? config.error : '不支持的文件类型'
        this.$message.error(error)
        this.fileList = []
        return
      }

      // 图片额外验证像素
      if (fileType === 'image') {
        try {
          console.log('dimensions---------', file)
          const dimensions = await this.getImageDimensions(file.raw)
          console.log(dimensions, 'dimensions')
          if (
            dimensions.width < config.minPixels ||
            dimensions.width > config.maxPixels ||
            dimensions.height < config.minPixels ||
            dimensions.height > config.maxPixels
          ) {
            throw new Error('图片尺寸不符合要求')
          }
        } catch (err) {
          console.log(err)
          this.$message.error(config.error)
          this.fileList = []
          return
        }
      }

      this.file = file.raw
      let FrontFileId = new FormData()
      FrontFileId.append('file', this.file)
      const resFront = await upload(FrontFileId, progressEvent => {
        // 计算上传进度百分比
        const percentCompleted = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        )
        console.log(percentCompleted, 'percentCompleted')

        this.percentage = percentCompleted == 100 ? 98 : percentCompleted
      })
      if (resFront.code == 200) {
        this.percentage = 100
        this.workFileIdUpd = resFront.dciFile
        this.workFileIdLocalUpd = resFront.ossFile
        this.fileSizeUpd = resFront.fileSize
        this.fileDurationMinutesUpd = resFront.durationMinutes
        // this.form.workName = this.getFileNameWithoutExtension(this.file.name)
        this.fileTypeType = this.getLabelsContainingVal(
          this.fileTypeTypeinit,
          this.getFileExtension(this.file.name)
        )
        // this.form.fileType = this.fileTypeType[0].value;
        this.WorkCategoryType = this.getLabelsContainingVal(
          this.WorkCategoryTypeinit,
          this.getFileExtension(this.file.name)
        )
        this.$message.success('上传成功')
      } else {
        this.$message.error(resFront.msg)
        return false
      }
    },
    // 获取图片尺寸
    getImageDimensions (file) {
      return new Promise((resolve, reject) => {
        const img = new Image()
        const reader = new FileReader()

        reader.onload = e => {
          img.onload = () => {
            resolve({
              width: img.naturalWidth,
              height: img.naturalHeight
            })
          }
          img.onerror = () => reject('图片加载失败')
          img.src = e.target.result
        }
        reader.readAsDataURL(file)
      })
    },
    getFileExtension (fileName) {
      // 使用 lastIndexOf 找到最后一个点的位置
      const lastDotIndex = fileName.lastIndexOf('.')

      // 如果没有找到点，返回空字符串
      if (lastDotIndex === -1) {
        return ''
      }

      // 返回后缀名（包括点）
      return fileName.substring(lastDotIndex + 1)
    },
    getLabelsContainingVal (data, val) {
      return data.filter(item =>
        item.label.toLowerCase().includes(val.toLowerCase())
      )
    },
    getFileNameWithoutExtension (fileName) {
      // 使用 lastIndexOf 找到最后一个点的位置
      const lastDotIndex = fileName.lastIndexOf('.')

      // 如果没有找到点，返回原始文件名
      if (lastDotIndex === -1) {
        return fileName
      }

      // 返回去掉后缀的文件名
      return fileName.substring(0, lastDotIndex)
    },
    beforeRemove (file, fileList) {
      this.file = null
      this.percentage = 0
    },
    getNewData () {
      // 获取当前日期对象
      const today = new Date()

      // 提取年、月、日
      const year = today.getFullYear()
      let month = today.getMonth() + 1 // 月份从0开始，需要加1
      let day = today.getDate()

      // 手动补零函数
      function padZero (num) {
        return num < 10 ? '0' + num : num
      }

      // 格式化月份和日期
      month = padZero(month)
      day = padZero(day)

      // 组合成指定格式字符串
      return `${year}-${month}-${day}`
    },
    async nextClick () {
      // 选择我是个人  著作权人不填代理人字段
      if (this.clickinfo == 1) {
        this.copyrightOwnerIdsType = []
        const resUser = await userList([this.userInfo.dciUserId])
        if (resUser && resUser.code == 200) {
          resUser.rows.map(e => {
            this.copyrightOwnerIdsType.push({
              value: e.dciUserId,
              label: e.certName,
              authorSignature: e.certificateNumber,
              identityStartTime: e.identityStartTime // 证件有效期开始时间
            })
          })
        }
        this.copyrightOwnerIdsType.map(e => {
          console.log(this.formAousz.authorNameList)
          if (e.value == this.userInfo.dciUserId) {
            this.formAousz.authorNameList[0].authorName = e.label
            this.formAousz.authorNameList[0].authorSignature = e.authorSignature
            this.formAousz.authorNameList[0].identityStartTime =
              e.identityStartTime
            this.form.authorName = e.label
            this.form.authorSignature = e.label
          }
        })
        this.form.ownershipWay = this.isPersonal ? 'PERSON' : 'ENTERPRISE'
      }
      // 在编辑某条表格记录
      let itemListId = 0
      if (this.sameWorkListitemID) {
        this.sameWorkList.map((e, i) => {
          if (e.dciWorkId == this.sameWorkListitemID) {
            itemListId = i + 1
          }
        })
      }
      if (this.sameWorkList.length > 0) {
        if (this.form.workName) {
          this.$refs.formName.validate(async valid => {
            if (valid) {
              // 检查是否存在 workFileId = 12 或 workFileIdLocal = 999 的项
              const exists = this.sameWorkList.some(
                item =>
                  item.workName === this.form.workName ||
                  item.workFileIdLocal === this.form.workFileIdLocal
              )

              if (exists) {
                this.$message.error('作品文件重复，请检查后重新上传作品文件')
                return
              }

              const date1 = new Date(this.form.creationCompletionDate)
              const date2 = new Date(this.form.firstPublicationDate)

              if (date1 > date2) {
                this.$message.error('首次发表日期不能早于创作完成日期')
                return
              }
              // 首次发表日期&创作完成日期,不能早于著作权人出生或设立日期
              if (
                this.formAousz.authorNameList[0] &&
                this.formAousz.authorNameList[0].identityStartTime
              ) {
                const identityStartTime = new Date(
                  this.formAousz.authorNameList[0].identityStartTime
                )
                if (date1 < identityStartTime || date2 < identityStartTime) {
                  this.$message.error(
                    '首次发表日期&创作完成日期,不能早于著作权人出生或设立日期'
                  )
                  return
                }
              }

              let workFileId = this.workFileIdUpd
              let workFileIdLocal = this.workFileIdLocalUpd
              let fileSize = this.fileSizeUpd
              let fileDurationMinutes = this.fileDurationMinutesUpd
              if (this.file) {
              } else {
                if (this.dciWorkId && !this.isLook) {
                  // 更新状态
                  workFileId = this.form.workFileId
                  workFileIdLocal = this.form.workFileIdLocal
                  fileSize = this.form.fileSize
                  fileDurationMinutes = this.form.fileDurationMinutes
                } else {
                  this.$message.error('请填选择文件')
                  return false
                }
              }
              let creationCompletionCode = ''
              // 地区选出是数组，需要处理成字符串
              if (
                typeof this.form.creationCompletionCode !== 'string' &&
                this.form.creationCompletionCode
              ) {
                creationCompletionCode =
                  this.form.creationCompletionCode[
                    this.form.creationCompletionCode.length - 1
                  ]
              } else {
                creationCompletionCode = this.form.creationCompletionCode
              }

              let firstPublicationCode = ''
              // 地区选出是数组，需要处理成字符串
              if (
                typeof this.form.firstPublicationCode !== 'string' &&
                this.form.firstPublicationCode
              ) {
                firstPublicationCode =
                  this.form.firstPublicationCode[
                    this.form.firstPublicationCode.length - 1
                  ]
              } else {
                firstPublicationCode = this.form.firstPublicationCode
              }
              let proxy = ''
              if (this.clickinfo == 2) {
                proxy = this.userInfo.userId
              }
              let worksea = {
                workFileId: workFileId, // 作品文件id
                workFileIdLocal: workFileIdLocal, // 作品文件id本系统OSS
                workName: this.form.workName, // 作品名称
                workCategory: this.form.workCategory, // 作品类型
                fileType: this.form.fileType, // 文件类型
                creationNature: this.form.creationNature, // 作品创作性质
                creationCompletionDate: this.form.creationCompletionDate, // 创作完成日期
                creationCompletionCode, // 地区编码
                publicationStatus: this.form.publicationStatus, // 作品发表状态
                firstPublicationDate: this.form.firstPublicationDate, // 首次发表日期
                firstPublicationCode, // 首次发表地区编码
                fileSize, // 文件大小
                fileDurationMinutes,
                proxy
              }

              if (this.dciWorkId || itemListId > 0) {
                // return
                if (itemListId > 0) {
                  worksea.dciWorkId = this.sameWorkListitemID
                }
                // 更新状态
                const res = await workUpdate({ ...this.form, ...worksea })

                if (res.code == 200) {
                  // 修改某一项
                  if (itemListId > 0) {
                    this.sameWorkList[itemListId - 1] = {
                      ...worksea
                    }

                    // this.$message.success("更新作品信息成功");
                  } else {
                    this.sameWorkList.push({
                      ...worksea,
                      dciWorkId: this.dciWorkId
                    })
                  }

                  this.active = 2 // 下一步
                  // 清空字段
                  this.form.workName = ''
                  this.form.workCategory = ''
                  this.form.fileType = ''
                  this.form.creationCompletionDate = ''
                  this.form.creationCompletionCode = ''
                  this.form.firstPublicationDate = ''
                  this.form.firstPublicationCode = ''
                  this.fileList = []
                  this.sameWorkListitemID = ''
                  this.percentage = 0
                } else {
                  this.$message.error('更新作品信息失败' + res.msg)
                  return false
                }
              } else {
                // 新增
                const res = await workSave({ ...this.form, ...worksea })
                if (res.code == 200) {
                  this.sameWorkList.push({ ...worksea, dciWorkId: res.data })

                  this.active = 2 // 下一步
                  // 清空字段
                  this.form.workName = ''
                  this.form.workCategory = ''
                  this.form.fileType = ''
                  this.form.creationCompletionDate = ''
                  this.form.creationCompletionCode = ''
                  this.form.firstPublicationDate = ''
                  this.form.firstPublicationCode = ''
                  this.fileList = []
                  this.sameWorkListitemID = ''
                  this.percentage = 0
                } else {
                  this.$message.error(res.msg)
                }
              }
            } else {
              this.$message.error('请填写完整信息')
              return false
            }
          })
        } else {
          this.active = 2 // 下一步
          // 清空字段
          this.form.workName = ''
          this.form.workCategory = ''
          this.form.fileType = ''
          this.form.creationCompletionDate = ''
          this.form.creationCompletionCode = ''
          this.form.firstPublicationDate = ''
          this.form.firstPublicationCode = ''
          this.fileList = []
          this.sameWorkListitemID = ''
          this.percentage = 0
        }
        return
      }

      this.$refs.formName.validate(async valid => {
        if (valid) {
          const date1 = new Date(this.form.creationCompletionDate)
          const date2 = new Date(this.form.firstPublicationDate)

          if (date1 > date2) {
            this.$message.error('首次发表日期不能早于创作完成日期')
            return
          }

          console.log(this.formAousz, 'zzzzzzzzzzzzzzzzzzz')

          // 首次发表日期&创作完成日期,不能早于著作权人出生或设立日期
          if (
            this.formAousz.authorNameList[0] &&
            this.formAousz.authorNameList[0].identityStartTime
          ) {
            const identityStartTime = new Date(
              this.formAousz.authorNameList[0].identityStartTime
            )
            if (date1 < identityStartTime || date2 < identityStartTime) {
              this.$message.error(
                '首次发表日期&创作完成日期,不能早于著作权人出生或设立日期'
              )
              return
            }
          }
          let workFileId = this.workFileIdUpd
          let workFileIdLocal = this.workFileIdLocalUpd
          let fileSize = this.fileSizeUpd
          let fileDurationMinutes = this.fileDurationMinutesUpd
          if (this.file) {
          } else {
            if (this.dciWorkId && !this.isLook) {
              // 更新状态
              workFileId = this.form.workFileId
              workFileIdLocal = this.form.workFileIdLocal
              fileSize = this.form.fileSize
              fileDurationMinutes = this.form.fileDurationMinutes
            } else {
              this.$message.error('请填选择文件')
              return false
            }
          }
          let creationCompletionCode = ''
          // 地区选出是数组，需要处理成字符串
          if (
            typeof this.form.creationCompletionCode !== 'string' &&
            this.form.creationCompletionCode
          ) {
            creationCompletionCode =
              this.form.creationCompletionCode[
                this.form.creationCompletionCode.length - 1
              ]
          } else {
            creationCompletionCode = this.form.creationCompletionCode
          }

          let firstPublicationCode = ''
          // 地区选出是数组，需要处理成字符串
          if (
            typeof this.form.firstPublicationCode !== 'string' &&
            this.form.firstPublicationCode
          ) {
            firstPublicationCode =
              this.form.firstPublicationCode[
                this.form.firstPublicationCode.length - 1
              ]
          } else {
            firstPublicationCode = this.form.firstPublicationCode
          }
          let proxy = ''
          if (this.clickinfo == 2) {
            proxy = this.userInfo.userId
          }
          let worksea = {
            workFileId: workFileId, // 作品文件id
            workFileIdLocal: workFileIdLocal, // 作品文件id本系统OSS
            workName: this.form.workName, // 作品名称
            workCategory: this.form.workCategory, // 作品类型
            fileType: this.form.fileType, // 文件类型
            creationNature: this.form.creationNature, // 作品创作性质
            creationCompletionDate: this.form.creationCompletionDate, // 创作完成日期
            creationCompletionCode, // 地区编码
            publicationStatus: this.form.publicationStatus, // 作品发表状态
            firstPublicationDate: this.form.firstPublicationDate, // 首次发表日期
            firstPublicationCode, // 首次发表地区编码
            fileSize, // 文件大小
            fileDurationMinutes,
            proxy
          }

          if (this.dciWorkId || itemListId > 0) {
            if (itemListId > 0) {
              worksea.dciWorkId = this.sameWorkListitemID
            }
            // 更新状态
            const res = await workUpdate({ ...this.form, ...worksea })
            if (res.code == 200) {
              // 修改某一项
              if (itemListId > 0) {
                this.sameWorkList[itemListId - 1] = {
                  ...worksea
                }
                // this.$message.success("更新作品信息成功");
              } else {
                this.sameWorkList.push({
                  ...worksea,
                  dciWorkId: this.dciWorkId
                })
              }

              this.active = 2 // 下一步
              this.form.workName = ''
              this.form.workCategory = ''
              this.form.fileType = ''
              this.form.creationCompletionDate = ''
              this.form.creationCompletionCode = ''
              this.form.firstPublicationDate = ''
              this.form.firstPublicationCode = ''
              this.fileList = []
              this.sameWorkListitemID = ''
              this.percentage = 0
            } else {
              this.$message.error('更新作品信息失败' + res.msg)
              return false
            }
          } else {
            // 新增
            const res = await workSave({ ...this.form, ...worksea })
            if (res.code == 200) {
              this.sameWorkList.push({ ...worksea, dciWorkId: res.data })

              this.active = 2 // 下一步
              this.form.workName = ''
              this.form.workCategory = ''
              this.form.fileType = ''
              this.form.creationCompletionDate = ''
              this.form.creationCompletionCode = ''
              this.form.firstPublicationDate = ''
              this.form.firstPublicationCode = ''
              this.fileList = []
              this.sameWorkListitemID = ''
              this.percentage = 0
            } else {
              this.$message.error(res.msg)
            }
          }
        } else {
          this.$message.error('请填写完整信息')
          return false
        }
      })
    },
    nextNewEDitClick () {
      // 在编辑某条表格记录
      let itemListId = 0
      if (this.sameWorkListitemID) {
        this.sameWorkList.map((e, i) => {
          if (e.dciWorkId == this.sameWorkListitemID) {
            itemListId = i + 1
          }
        })
      }
      this.$refs.formName.validate(async valid => {
        if (valid) {
          const date1 = new Date(this.form.creationCompletionDate)
          const date2 = new Date(this.form.firstPublicationDate)

          if (date1 > date2) {
            this.$message.error('首次发表日期不能早于创作完成日期')
            return
          }
          // 首次发表日期&创作完成日期,不能早于著作权人出生或设立日期
          if (
            this.formAousz.authorNameList[0] &&
            this.formAousz.authorNameList[0].identityStartTime
          ) {
            const identityStartTime = new Date(
              this.formAousz.authorNameList[0].identityStartTime
            )
            if (date1 < identityStartTime || date2 < identityStartTime) {
              this.$message.error(
                '首次发表日期&创作完成日期,不能早于著作权人出生或设立日期'
              )
              return
            }
          }

          // // 检查是否存在 workFileId = 12 或 workFileIdLocal = 999 的项
          // const exists = this.sameWorkList.some(item => item.workName === this.form.workName || item.workFileIdLocal === this.form.workFileIdLocal);

          // if (exists) {
          //   this.$message.error("作品文件重复，请检查后重新上传作品文件");
          //   return;
          // }

          let workFileId = this.workFileIdUpd
          let workFileIdLocal = this.workFileIdLocalUpd
          let fileSize = this.fileSizeUpd
          let fileDurationMinutes = this.fileDurationMinutesUpd
          if (this.file) {
          } else {
            workFileId = this.form.workFileId
            workFileIdLocal = this.form.workFileIdLocal
            fileSize = this.form.fileSize
            fileDurationMinutes = this.form.fileDurationMinutes
          }
          let creationCompletionCode = ''
          // 地区选出是数组，需要处理成字符串
          if (
            typeof this.form.creationCompletionCode !== 'string' &&
            this.form.creationCompletionCode
          ) {
            creationCompletionCode =
              this.form.creationCompletionCode[
                this.form.creationCompletionCode.length - 1
              ]
          } else {
            creationCompletionCode = this.form.creationCompletionCode
          }

          let firstPublicationCode = ''
          // 地区选出是数组，需要处理成字符串
          if (
            typeof this.form.firstPublicationCode !== 'string' &&
            this.form.firstPublicationCode
          ) {
            firstPublicationCode =
              this.form.firstPublicationCode[
                this.form.firstPublicationCode.length - 1
              ]
          } else {
            firstPublicationCode = this.form.firstPublicationCode
          }
          let worksea = {
            workFileId: workFileId, // 作品文件id
            workFileIdLocal: workFileIdLocal, // 作品文件id本系统OSS
            workName: this.form.workName, // 作品名称
            workCategory: this.form.workCategory, // 作品类型
            fileType: this.form.fileType, // 文件类型
            creationNature: this.form.creationNature, // 作品创作性质
            creationCompletionDate: this.form.creationCompletionDate, // 创作完成日期
            creationCompletionCode, // 地区编码
            publicationStatus: this.form.publicationStatus, // 作品发表状态
            firstPublicationDate: this.form.firstPublicationDate, // 首次发表日期
            firstPublicationCode, // 首次发表地区编码
            fileSize, // 文件大小
            fileDurationMinutes
          }

          worksea.dciWorkId = this.sameWorkListitemID
          // 更新状态
          const res = await workUpdate({ ...this.form, ...worksea })

          if (res.code == 200) {
            // 修改某一项
            this.sameWorkList[itemListId - 1] = {
              ...worksea
            }

            // 清空字段
            this.form.workName = ''
            this.form.workCategory = ''
            this.form.fileType = ''
            this.form.creationCompletionDate = ''
            this.form.creationCompletionCode = ''
            this.form.firstPublicationDate = ''
            this.form.firstPublicationCode = ''
            this.fileList = []
            this.sameWorkListitemID = ''
            this.percentage = 0
          } else {
            this.$message.error('更新作品信息失败' + res.msg)
            return false
          }
        } else {
          this.$message.error('请填写完整信息')
          return false
        }
      })
    },
    //同作者再次添加作品
    nextNewClick () {
      this.$refs.formName.validate(async valid => {
        if (valid) {
          // 检查是否存在 workName 相同 或 workFileIdLocal相同的项
          const exists = this.sameWorkList.some(
            item =>
              item.workName === this.form.workName ||
              item.workFileIdLocal === this.form.workFileIdLocal
          )

          if (exists) {
            this.$message.error('作品文件重复，请检查后重新上传作品文件')
            return
          }

          const date1 = new Date(this.form.creationCompletionDate)
          const date2 = new Date(this.form.firstPublicationDate)

          if (date1 > date2) {
            this.$message.error('首次发表日期不能早于创作完成日期')
            return
          }
          // 首次发表日期&创作完成日期,不能早于著作权人出生或设立日期
          if (
            this.formAousz.authorNameList[0] &&
            this.formAousz.authorNameList[0].identityStartTime
          ) {
            const identityStartTime = new Date(
              this.formAousz.authorNameList[0].identityStartTime
            )
            if (date1 < identityStartTime || date2 < identityStartTime) {
              this.$message.error(
                '首次发表日期&创作完成日期,不能早于著作权人出生或设立日期'
              )
              return false
            }
          }

          let workFileId = this.workFileIdUpd
          let workFileIdLocal = this.workFileIdLocalUpd
          let fileSize = this.fileSizeUpd
          let fileDurationMinutes = this.fileDurationMinutesUpd
          if (this.file) {
          } else {
            if (this.dciWorkId && !this.isLook) {
              // 更新状态
              workFileId = this.dciWorkId.workFileId
              workFileIdLocal = this.dciWorkId.workFileIdLocal
              fileSize = this.dciWorkId.fileSize
              fileDurationMinutes = this.dciWorkId.fileDurationMinutes
            } else {
              this.$message.error('请填选择文件')
              return false
            }
          }
          let creationCompletionCode = ''
          // 地区选出是数组，需要处理成字符串
          if (
            typeof this.form.creationCompletionCode !== 'string' &&
            this.form.creationCompletionCode
          ) {
            creationCompletionCode =
              this.form.creationCompletionCode[
                this.form.creationCompletionCode.length - 1
              ]
          } else {
            creationCompletionCode = this.form.creationCompletionCode
          }

          let firstPublicationCode = ''

          // 地区选出是数组，需要处理成字符串
          if (
            typeof this.form.firstPublicationCode !== 'string' &&
            this.form.firstPublicationCode
          ) {
            firstPublicationCode =
              this.form.firstPublicationCode[
                this.form.firstPublicationCode.length - 1
              ]
          } else {
            firstPublicationCode = this.form.firstPublicationCode
          }

          let proxy = ''
          if (this.clickinfo == 2) {
            proxy = this.userInfo.userId
          }

          let worksea = {
            workFileId: workFileId, // 作品文件id
            workFileIdLocal: workFileIdLocal, // 作品文件id本系统OSS
            workName: this.form.workName, // 作品名称
            workCategory: this.form.workCategory, // 作品类型
            fileType: this.form.fileType, // 文件类型
            creationNature: this.form.creationNature, // 作品创作性质
            creationCompletionDate: this.form.creationCompletionDate, // 创作完成日期
            creationCompletionCode, // 地区编码
            publicationStatus: this.form.publicationStatus, // 作品发表状态
            firstPublicationDate: this.form.firstPublicationDate, // 首次发表日期
            firstPublicationCode, // 首次发表地区编码
            fileSize, // 文件大小
            fileDurationMinutes,
            proxy
          }

          // this.sameWorkList.push(worksea)
          // return

          const res = await workSave({ ...this.form, ...worksea })
          console.log(res)
          if (res.code == 200) {
            this.$message.success('保存成功')
            this.sameWorkList.push({ ...worksea, dciWorkId: res.data })

            // 清空字段
            this.form.workName = ''
            this.form.workCategory = ''
            this.form.fileType = ''
            this.form.creationCompletionDate = ''
            this.form.creationCompletionCode = ''
            this.form.firstPublicationDate = ''
            this.form.firstPublicationCode = ''
            this.fileList = []
            this.percentage = 0
          } else {
            this.$message.error(res.msg)
          }

          console.log(this.sameWorkList)
        } else {
          this.$message.error('请填写完整信息')
          return false
        }
      })
    },
    showStatus (r) {
      console.log(r)
    },
    copyrightDel (scope) {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        this.sameWorkList.splice(scope.$index, 1)
      }).catch(() => {})
    },
    copyrigEdit (scope) {
      this.form = { ...this.form, ...scope.row }
      this.sameWorkListitemID = scope.row.dciWorkId
      this.fileList = [
        { name: scope.row.workFileIdLocal, url: scope.row.workFileIdLocal }
      ]
    },
    editInfo () {
      // 字段返现去修改
      this.form.workName = this.infoForm.workName
      this.form.workCategory = this.infoForm.workCategory
      this.form.fileType = this.infoForm.fileType
      this.form.creationCompletionDate = this.infoForm.creationCompletionDate
      this.form.creationCompletionCode = this.infoForm.creationCompletionCode
      this.form.firstPublicationDate = this.infoForm.firstPublicationDate
      this.form.firstPublicationCode = this.infoForm.firstPublicationCode
      this.sameWorkListitemID = this.infoForm.dciWorkId
      this.fileList = [
        {
          name: this.infoForm.workFileIdLocal,
          url: this.infoForm.workFileIdLocal
        }
      ]
      this.active = 1
    },
    async downFile (path) {
      this.dialogVisilock = true
      this.dialogVisilockpath = path
      const resUrl = await this.$download.file(path)
      this.selectedFile = resUrl
      this.fileType = path.split('/')[0]
    },
    downCheck (path) {
      const parts = path.split('/')
      this.$download.name(path, parts[1] + '.' + parts[0])
    }
  }
}
</script>
<style lang="scss" scoped>
.title-jibne {
  letter-spacing: normal;
  color: #333333;
  line-height: normal;
  text-align: left;
  font-family: 'Arial Negreta', 'Arial Normal', 'Arial', sans-serif;
  font-weight: 700;
  font-style: normal;
  font-size: 20px;
  white-space: nowrap;
  text-transform: none;
  text-rendering: optimizeLegibility;
  -webkit-font-feature-settings: 'kern';
  font-kerning: normal;
}

.stepscc {
  margin: 30px auto;
  width: 1200px;
}

.asefaeaf {
  padding: 20px;
  background-color: rgba(242, 242, 242, 1);
}

.unslider {
  margin: 0 auto;
  width: 1200px;
  height: 866px;
  display: flex;
  justify-content: space-around;
  align-items: center;

  > div {
    width: 470px;
    height: 380px;
    border-style: solid;
    border-color: rgba(121, 121, 121, 1);
    border-radius: 10px;
    border-width: 1px;
    text-align: center;
    display: flex;

    &:hover {
      cursor: pointer;
    }

    flex-direction: column;
    justify-content: center;

    > :nth-child(1) {
      font-size: 160px;
    }

    > :nth-child(2) {
      margin: 20px;
      letter-spacing: normal;
      color: #333333;
      line-height: normal;
      font-size: 24px;
      font-family: 'Arial Negreta', 'Arial Normal', 'Arial', sans-serif;
      font-weight: 700;
      font-style: normal;
      white-space: nowrap;
      text-transform: none;
      text-rendering: optimizeLegibility;
      -webkit-font-feature-settings: 'kern';
      font-kerning: normal;
    }
  }
}

.form-aut {
  margin: 0 auto;
  width: 800px;
}

.el-select-cc {
  width: 500px;
}

.card-aut-cc {
  margin-top: 10px;
}

.span-cc {
  letter-spacing: normal;
  color: #333333;
  line-height: normal;
  font-size: 18px;
  text-align: left;
  font-family: 'Arial Negreta', 'Arial Normal', 'Arial', sans-serif;
  font-weight: 700;
  font-style: normal;
  word-wrap: break-word;
  text-transform: none;
  text-rendering: optimizeLegibility;
  -webkit-font-feature-settings: 'kern';
  font-kerning: normal;
  margin-bottom: 10px;
}

.nave-dd {
  background-color: #f2f2f2;
  padding: 10px 20px 10px 20px;
}

.seccbtn {
  display: flex;

  > div {
    visibility: inherit;
    font-family: 'Arial Normal', 'Arial', sans-serif;
    font-weight: 400;
    font-style: normal;
    font-size: 13px;
    letter-spacing: normal;
    text-align: center;
    line-height: normal;
    text-transform: none;
    width: 159px;
    height: 51px;
    background: inherit;
    background-color: rgba(242, 242, 242, 1);
    box-sizing: border-box;
    border-width: 2px;
    border-style: solid;
    border-color: rgba(242, 242, 242, 1);
    border-radius: 5px;
    box-shadow: none;
    color: #000000;
    line-height: 51px;
    margin-right: 15px;
    cursor: not-allowed;
  }

  .chekbtn {
    visibility: inherit;
    font-family: 'Arial Normal', 'Arial', sans-serif;
    font-weight: 400;
    font-style: normal;
    font-size: 13px;
    letter-spacing: normal;
    text-align: center;
    line-height: normal;
    text-transform: none;
    width: 159px;
    height: 51px;
    line-height: 51px;
    background: inherit;
    background-color: rgba(0, 121, 254, 1);
    box-sizing: border-box;
    border-width: 2px;
    border-style: solid;
    border-color: rgba(242, 242, 242, 1);
    border-radius: 5px;
    box-shadow: none;
    color: #ffffff;
  }
}

.seccbtn-sfda {
  display: flex;

  > div {
    visibility: inherit;
    font-family: 'Arial Normal', 'Arial', sans-serif;
    font-weight: 400;
    font-style: normal;
    font-size: 13px;
    letter-spacing: normal;
    text-align: center;
    line-height: normal;
    text-transform: none;
    width: 159px;
    height: 51px;
    background: inherit;
    background-color: rgba(242, 242, 242, 1);
    box-sizing: border-box;
    border-width: 2px;
    border-style: solid;
    border-color: rgba(242, 242, 242, 1);
    border-radius: 5px;
    box-shadow: none;
    color: #000000;
    line-height: 51px;
    margin-right: 15px;
    cursor: pointer;
  }

  .chekbtn {
    visibility: inherit;
    font-family: 'Arial Normal', 'Arial', sans-serif;
    font-weight: 400;
    font-style: normal;
    font-size: 13px;
    letter-spacing: normal;
    text-align: center;
    line-height: normal;
    text-transform: none;
    width: 159px;
    height: 51px;
    line-height: 51px;
    background: inherit;
    background-color: rgba(0, 121, 254, 1);
    box-sizing: border-box;
    border-width: 2px;
    border-style: solid;
    border-color: rgba(242, 242, 242, 1);
    border-radius: 5px;
    box-shadow: none;
    color: #ffffff;
  }
}

.haoma-css {
  > div {
    margin: 10px 0;
  }

  .haoma-css-cc {
    display: flex;

    > :nth-child(1) {
      width: 150px;
      font-size: 16px;
      line-height: 40px;
      font-weight: 700;
    }

    > :nth-child(2) {
      width: 328px;

      .el-input-cc {
        width: 100%;
      }
    }
  }
}

.stepscc-err {
  margin-bottom: 20px;
  padding: 0 20px;
}

.haoma-css-cc-no1 {
  padding-left: 100px;
}

.btn-cc-disc {
  margin-top: 15px;
}

.table-dci {
  margin-bottom: 20px;
}

.never-span-cc {
  width: 100%;
  display: flex;

  > div {
    flex: 1;

    .nawe-sadg {
      display: flex;

      > :nth-child(n) {
        line-height: 50px;
      }

      > :nth-child(1) {
        width: 150px;
        font-size: 16px;
        font-weight: 700;
        line-height: 50px;
      }

      .nawe-sadg-sdfa {
        margin-left: 10px;
      }
    }
  }
}

.author-input-row {
  display: flex;
  align-items: center;
  gap: 10px;
}

.author-delete-btn {
  flex-shrink: 0;
}

.work-name-tip {
  margin-top: 6px;
  color: #f56c6c;
  font-size: 13px;
  line-height: 1.5;
}

.work-upload-edit-tip {
  margin-top: 8px;
  color: #f56c6c;
  font-size: 13px;
  line-height: 1.5;
}

.risk-tip-card {
  margin: 0 0 16px;
  border: 1px solid #f5c6cb;
  background: #fff8f8;
}

.risk-tip-title {
  font-size: 16px;
  font-weight: 700;
  color: #c0392b;
  margin-bottom: 8px;
}

.risk-tip-intro {
  font-size: 13px;
  color: #666;
  line-height: 1.6;
  margin-bottom: 8px;
}

.risk-tip-manual {
  font-size: 13px;
  margin-bottom: 8px;

  a {
    color: #0079fe;
    word-break: break-all;
  }
}

.risk-tip-list {
  margin: 0;
  padding-left: 20px;
  color: #333;
  font-size: 13px;
  line-height: 1.7;
}
</style>
